export const appsConfig = {
  "sollai-sol": {
    name: "Sollai Sol",
    android:
      "https://play.google.com/store/apps/details?id=com.ulagatamizhar.sollai_sol",
    ios:
      "https://apps.apple.com/gb/app/sollai-sol/id6756616907",
    fallback: "https://ulagatamizhar.net/ourapps"
  },

  // 👉 ADD NEW APPS LIKE THIS
//   "another-app": {
//     name: "Another App",
//     android: "https://play.google.com/store/apps/details?id=com.example.app",
//     ios: "https://apps.apple.com/app/id123456789",
//     fallback: "https://yourwebsite.com/another-app"
//   }
};
